import { p as proxyCustomElement, H, h, a as Host } from './index.js';
import { d as defineCustomElement$1 } from './p-BqzjvfBR.js';

const listItemMetaCss = ":host{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;align-items:center;box-sizing:border-box;color:var(--jw-theme-surface-text-helper-color);display:flex;flex:none;font-family:Open Sans;font-size:.875rem;font-weight:400;justify-content:center;letter-spacing:-.0004em;line-height:1.25rem;line-height:normal;padding:.5rem .75rem;text-align:center}:host *,:host :after,:host :before{box-sizing:inherit}:host img{flex:none;overflow:hidden;text-overflow:ellipsis;white-space:pre-line}";

const WuiListItemMeta = /*@__PURE__*/ proxyCustomElement(class WuiListItemMeta extends H {
    constructor(registerHost) {
        super();
        if (registerHost !== false) {
            this.__registerHost();
        }
        this.__attachShadow();
        this.loading = false;
    }
    render() {
        return (h(Host, { key: 'ad1048940c69d8cb785aa1a9e30181dc0e418f29', role: "listitem", tabIndex: -1 }, this.loading ? h("wui-loader", { type: "dots" }) : this.label));
    }
    static get style() { return listItemMetaCss; }
}, [257, "wui-list-item-meta", {
        "label": [1],
        "loading": [4]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["wui-list-item-meta", "wui-loader"];
    components.forEach(tagName => { switch (tagName) {
        case "wui-list-item-meta":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, WuiListItemMeta);
            }
            break;
        case "wui-loader":
            if (!customElements.get(tagName)) {
                defineCustomElement$1();
            }
            break;
    } });
}
defineCustomElement();

export { WuiListItemMeta as W, defineCustomElement as d };
